// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import request from './request'

/**
 * @description 鉴定师列表
 */
export function appraisalPersonListApi(data) {
  return request.get('appraisal/person/list', data)
}

/**
 * @description 添加鉴定师
 */
export function saveAppraisalPersonDataApi(data) {
  return request.post('appraisal/person/save', data)
}

/**
 * @description 鉴定师详情
 */
export function appraisalPersonDetailApi(id) {
  return request.get(`appraisal/person/detail/${id}`)
}

/**
 * @description 删除鉴定师
 */
export function appraisalPersonDeleteApi(id) {
  return request.delete(`appraisal/person/delete/${id}`)
}

/**
 * @description 获取类别
 */
export function appraisalConfigPlatformTypeApi() {
  return request.get(`appraisal/config/platform/type`)
}

/**
 * @description 获取配置
 */
export function appraisalConfigDetailApi() {
  return request.get(`appraisal/config/detail`)
}

/**
 * @description 保存配置
 */
export function saveAppraisalConfigDataApi(data) {
  return request.post(`appraisal/config/save`, data)
}

/**
 * @description 品类列表
 */
export function appraisalCateListApi(data) {
  return request.get(`appraisal/cate/list`, data)
}

/**
 * @description 添加品类
 */
export function saveAppraisalCateDataApi(data) {
  return request.post(`appraisal/cate/save`, data)
}

/**
 * @description 添加品类
 */
export function appraisalCateDetailApi(id) {
  return request.post(`appraisal/cate/detail/${id}`)
}

/**
 * @description 删除品类
 */
export function appraisalCateDeleteApi(id) {
  return request.delete(`appraisal/cate/delete/${id}`)
}

/**
 * @description 品牌列表
 */
export function appraisalBrandListApi(data) {
  return request.get(`appraisal/brand/list`, data)
}
/**
 * @description 保存品牌
 */
export function saveAppraisalBrandDataApi(data) {
  return request.post(`appraisal/brand/save`, data)
}

/**
 * @description 品牌详情
 */
export function appraisalBrandDetailApi(id) {
  return request.get(`appraisal/brand/detail/${id}`)
}
/**
 * @description 删除品牌
 */
export function appraisalBrandDeleteApi(id) {
  return request.delete(`appraisal/brand/delete/${id}`)
}

/**
 * @description 实物鉴定统计
 */
export function appraisalEntityChartListApi() {
  return request.get(`appraisal/order/entity/chart`)
}

/**
 * @description 实物鉴定列表
 */
export function appraisalEntityListApi(data) {
  return request.get(`appraisal/order/entity/list`, data)
}


/**
 * @description 实物鉴定订单删除
 */
export function appraisalEntityOrderDeleteApi(id) {
  return request.delete(`appraisal/order/delete/${id}`)
}
/**
 * @description 实物鉴定订单取消寄件
 */
export function appraisalEntityOrderCancelExpressApi(id) {
  return request.post(`appraisal/order/cancel/express/${id}`)
}
/**
 * @description 实物订单 -- 编辑状态
 */
export function appraisalOrderEntityUpdateApi(id) {
  return request.get(`appraisal/order/entity/status/${id}/form`)
}

/**
 * @description 实物订单 -- 详情
 */
export function appraisalOrderEntityDetailApi(id) {
  return request.get(`appraisal/order/entity/detail/${id}`)
}

/**
 * @description 修改用户信息
 */
export function appraisalOrderEntityAuditApi(id,data) {
  return request.post(`appraisal/order/entity/audit/${id}`, data)
}
/**
 * @description 获取在线鉴定头部信息
 */
export function appraisalOnlineChartListApi() {
  return request.get(`appraisal/order/online/chart`, )
}
/**
 * @description 在线订单 -- 编辑状态
 */
export function appraisalOrderOnlineUpdateApi(id) {
  return request.get(`appraisal/order/online/status/${id}/form`)
}

/**
 * @description 获取品类
 */
export function appraisalCateSelectListApi() {
  return request.get(`appraisal/cate/select/list`)
}

/**
 * @description 获取品牌
 */
export function appraisalBrandSelectListApi() {
  return request.get(`appraisal/brand/select/list`)
}

/**
 * 获取分类
 */
export function appraisalCategoryListApi() {
  return request.get(`appraisal/category/list`)
}
/**
 * 获取上一级分类
 */
export function appraisalCategoryMenuListApi(level) {
  return request.get(`appraisal/category/menu/list/${level}`)
}

/**
 * 报存分类
 */
export function appraisalCategoryCreateApi(data) {
  return request.post(`appraisal/category/create`,data)
}

/**
 * 分类详情
 */
export function appraisalCategoryDetailApi(id) {
  return request.get(`appraisal/category/detail/${id}`,)
}

/**
 * 分类删除
 */
export function appraisalCategoryDeleteApi(id) {
  return request.delete(`appraisal/category/delete/${id}`,)
}

/**
 * 分类开启
 */
export function appraisalCategoryStatusApi(id,status) {
  return request.post(`appraisal/category/status/${id}`,{ status })
}







